module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOC43ODQiIGhlaWdodD0iMzguNzg0IiB2aWV3Qm94PSIwIDAgMzguNzg0IDM4Ljc4NCI+PHBhdGggZmlsbD0iIzNBNTU5RiIgZD0iTTAgMHYzOC43ODRoMjAuNjU1VjIzLjgwMmgtNS4wNDl2LTYuMTE2aDUuMDQ5VjEyLjU1YTYuNzYzIDYuNzYzIDAgMCAxIDYuNzY0LTYuNzYzaDUuMjc4djUuNUgyOC45MmEyLjE0OCAyLjE0OCAwIDAgMC0yLjE0OSAyLjE0OXY0LjI1MWg1LjgzMmwtLjgwNiA2LjExNmgtNS4wMjV2MTQuOTgxaDEyLjAxM1YwSDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/shareIconFacebook.svg
// module id = 96
// module chunks = 0